import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./components/login";
import Signup from "./components/signup";
import ConversationPage from "./components/conversationPage";
import { AuthProvider } from "./context/authContext";
import ProtectedRoute from "./Routes/protectedRoute";
import AuthRoute from "./Routes/authRoute";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ResetPassword from "./components/ResetPassword";
import ContactUs from "./components/ContactUs";
import Onboarding from "./components/Onboarding";
import Recharge from "./components/Recharge";
import SiteSettings from "./components/SiteSettings";
import { ConfigProvider } from 'antd';
import {theme} from './theme/theme';
import TermsOfUse from "./components/TermsOfUse";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Schedules from "./components/Schedules";

function App() {
  const isTokenExpired = () => {
    const token = localStorage.getItem("token");
    if (!token) return true;

    const payload = JSON.parse(atob(token.split(".")[1]));
    const now = Date.now() / 1000;
    return now > payload.exp;
  };

  return (
    <Router>
      <AuthProvider>
        <ConfigProvider theme={theme}>        
          <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
          <div className="App h-[100vh] min-w-screen ">
            <Routes>
              <Route path="/" element={<AuthRoute element={<Login />} />} />
              <Route
                path="/signup"
                element={<AuthRoute element={<Signup />} />}
              />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route
                path="/site-settings"
                element={<ProtectedRoute element={<SiteSettings />} />}
              />
              <Route
                path="/recharge"
                element={<ProtectedRoute element={<Recharge />} />}
              />
              <Route
                path="/schedules"
                element={<Schedules />}
              />              
              <Route
                path="/chat"
                element={<ProtectedRoute element={<ConversationPage />} />}
              />
              <Route
                path="/onboarding"
                element={<ProtectedRoute element={ <Onboarding /> } />}
              />
              <Route
                path="*"
                element={
                  isTokenExpired() ? (
                    <Navigate to="/" />
                  ) : (
                    <Navigate to="/chat" />
                  )
                }
              />
              <Route path="/resetPassword" element={<ResetPassword />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />              
            </Routes>
          </div>
          </GoogleOAuthProvider>
        </ConfigProvider>
      </AuthProvider>
    </Router>
  );
}
//Dummy1122
export default App;
